const ADSENSE_SCRIPT_URL = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js';

const createAdSenseScriptUrl = (clientId) => `${ADSENSE_SCRIPT_URL}?client=${encodeURIComponent(clientId)}`;

/**
 * The AdSense <script> tag for the <head> of pre-rendered pages, which AdSense needs to find
 * on every page to review the site. Empty until a publisher ID is configured.
 */
export function createAdSenseScriptHtml(clientId) {
  if (!clientId) return '';
  return `<script async src="${createAdSenseScriptUrl(clientId)}" crossorigin="anonymous"></script>`;
}

/**
 * Loads the AdSense script once. Does nothing until a publisher ID is configured.
 */
export function loadAdSenseScript(clientId) {
  if (!clientId || typeof document === 'undefined') return;
  if (document.querySelector(`script[src^="${ADSENSE_SCRIPT_URL}"]`)) return;
  const script = document.createElement('script');
  script.async = true;
  script.src = createAdSenseScriptUrl(clientId);
  script.crossOrigin = 'anonymous';
  document.head.appendChild(script);
}

/**
 * Asks AdSense to fill the ad units that are on the page.
 */
export function requestAdFill() {
  try {
    (window.adsbygoogle = window.adsbygoogle || []).push({});
  } catch {
    // Ad blockers and unfilled slots are fine: the page just shows no ad.
  }
}
